import { render, staticRenderFns } from "./edit-questionOfPaper.vue?vue&type=template&id=78615065&scoped=true&"
import script from "./edit-questionOfPaper.vue?vue&type=script&lang=ts&"
export * from "./edit-questionOfPaper.vue?vue&type=script&lang=ts&"
import style0 from "./edit-questionOfPaper.vue?vue&type=style&index=0&id=78615065&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78615065",
  null
  
)

export default component.exports